import { siteUrl } from './metadata';

export const indexNowKey = '1f3e769e4ced47d7b88eef65a171a7ff';
export const indexNowEndpoint = 'https://api.indexnow.org/indexnow';
export const indexNowKeyLocation = `${siteUrl}/${indexNowKey}.txt`;
export const indexNowBatchSize = 10000;

export const indexNowRunStatuses = ['idle', 'running', 'done', 'failed'] as const;
export type IIndexNowRunStatus = (typeof indexNowRunStatuses)[number];

export const indexNowRunPhases = ['fetching_sitemaps', 'submitting', 'done', 'failed'] as const;
export type IIndexNowRunPhase = (typeof indexNowRunPhases)[number];
